import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ConfirmDialogData} from "../confirm-dialog/confirm-dialog.component";
import {FilterService} from "../../services/filter.service";
import {Uuid} from "../../interface/response/uuid";
import {CommissionAnnexService} from "../../services/commission-annex.service";
import {OFWCA_STATUS_ACTIVE, OFWCA_STATUS_NEW} from "../../services/dict.service";

export interface CloneAnnexesDialogData {
  text: string;
  commissionAnnexId: string;
}

@Component({
  selector: 'app-clone-annexes-dialog',
  templateUrl: './clone-annexes-dialog.component.html',
  styleUrls: ['./clone-annexes-dialog.component.scss']
})
export class CloneAnnexesDialogComponent implements OnInit {
  text = '';
  commissionAnnexId = '';
  processingRequest = false;
  enableFilters: string[] = null;
  initialFilters: any;
  success = false;
  response: any;
  readonly OFWCA_STATUS_ACTIVE = OFWCA_STATUS_ACTIVE;
  readonly OFWCA_STATUS_NEW = OFWCA_STATUS_NEW;
  constructor(
    public dialogRef: MatDialogRef<CloneAnnexesDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: CloneAnnexesDialogComponent,
    private filterService: FilterService,
    private commissionAnnexService: CommissionAnnexService
  ) {
    this.text = data.text;
    this.commissionAnnexId = data.commissionAnnexId;
    this.parseFilters();
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      ofwca: 'string',
      partner: 'string',
    }, filters);
  }
  ngOnInit(): void {
  }

  confirm(): void {
    this.processingRequest = true;

    this.commissionAnnexService.cloneAnnexes(this.commissionAnnexId, {newPartner: this.initialFilters.partner, newOfwca: this.initialFilters.ofwca})
      .subscribe((response) => {
        if (response){
          this.response = response;
          this.success = true;
        }
      });
  }

  decline(): void {
    this.dialogRef.close(false);
  }

  close(): void {
    this.dialogRef.close(true);
  }
}
